"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkDefaults = void 0;
exports.darkDefaults = {
    white: 'gray920',
    gray100: 'gray900',
    gray200: 'gray920',
    gray300: 'grayBlue800',
    gray400: 'gray700',
    gray500: 'grayBlue800',
    gray600: 'grayBlue800',
    gray700: 'grayBlue200',
    gray800: 'grayBlue200',
    gray900: 'grayBlue200',
    gray920: 'grayBlue200',
    black: 'gray100',
    red300: 'yellow100',
    brand500: 'brand500',
    red700: 'red700',
    blue500: 'grayBlue200',
    blue700: 'grayBlue200',
    grayBlue100: 'gray920',
    grayBlue200: 'gray920',
    grayBlue300: 'gray920',
    grayBlue400: 'blue700',
    grayBlue500: 'grayBlue500',
    grayBlue700: 'grayBlue400',
    grayBlue800: 'gray300',
    grayBlue850: 'gray300',
    grayBlue900: 'gray300',
    blue400: 'grayBlue700',
    blue600: 'grayBlue200',
};
